import styled from 'styled-components';
import { mediaQuery } from '@carvana/showroom-css-theme';

export const Label = styled.div<any>`
  text-align: left;
  font-weight: ${props => props.bold ? '700' : '400'};
  padding-bottom: 12px;
  font-size: 16px;
  color: var(--cvna-color-blue-6);
`;

export const InstructionBox = styled.div`
  font-size: 14px;
  text-align: center;
`;

export const FormBox = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  gap: 8px;
  flex: 1;
`;

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  margin-top: 16px;

  button {
    width: 100%;
  }
`;